import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/buttons/Button';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { cdnImage } from '@/utils/image-utils';
import { useFluidOpen } from '@/features/cashier/fluid/fluidPaymentsStore';
import { BaseModalProps } from '@/features/modal/types';

export const RewardsWheelDepositRequirementModal = ({ closeModal }: BaseModalProps) => {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const openCashier = useFluidOpen();

  const handleCtaClick = () => {
    closeModal();
    openCashier();
  };

  const handleBackClick = () => {
    closeModal();
    navigate('/games');
  };

  return (
    <div className="relative rounded-xl overflow-hidden bg-rewardsWheelBg p-8">
      <img
        src={cdnImage('rewards-wheel/rewards-wheel-hero-locked.png', {
          width: '350px',
          height: 'auto',
          dpr: '2',
        })}
        className="mx-auto"
        width="350px"
        alt={intl.formatMessage({ id: 'rewardReel.h1' })}
      />
      <div className="text-white max-w-sm flex flex-col items-center gap-4 mt-4">
        <div className="text-lg font-bold">
          {intl.formatMessage({ id: 'rewardsWheelDeposit.title' })}
        </div>
        <div className="text-md">{intl.formatMessage({ id: 'rewardsWheelDeposit.subtitle' })}</div>
        <div className="flex w-full flex-col gap-y-2">
          <Button
            data-cy="rewards-wheel-modal-locked-accept-button"
            onClickHandler={handleCtaClick}
            btnType="primary"
            text={intl.formatMessage({ id: 'rewardsWheelDeposit.cta.deposit' })}
          />
          <Button
            onClickHandler={handleBackClick}
            btnType="secondary"
            text={intl.formatMessage({ id: 'rewardsWheelDeposit.cta.lobby' })}
          />
        </div>
      </div>
    </div>
  );
};
